import { render, staticRenderFns } from "./AddPopulationGroup.vue?vue&type=template&id=0048ef6a"
import script from "./AddPopulationGroup.vue?vue&type=script&lang=js"
export * from "./AddPopulationGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports